import { render } from "./ApplicationFollowupComponent.vue?vue&type=template&id=4855ce8b"
import script from "./ApplicationFollowupComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationFollowupComponent.vue?vue&type=script&lang=js"

import "./ApplicationFollowupComponent.vue?vue&type=style&index=0&id=4855ce8b&lang=scss"
script.render = render

export default script